module.exports = __webpack_public_path__ + "static/media/bg.8f3b3f86.jpg";